import type { Paths } from "type-fest";
import { z } from "zod";

import { zOutSchema2 } from "./common";

import { ListParams, Pagination } from "~/shared/zod";

const zOut = Pagination.Page.zSchema(zOutSchema2);
type Out = z.infer<typeof zOut>;

type Key = Paths<Out["items"][number]>;

const INCLUDED_KEYS = [
  "id",
  "rating",
  "pros",
  "cons",
  "text",
  "customer.firstName",
  "customer.lastName",
  "customer.email",
  "customer.phone",
  "isApproved",
  "createdAt",
  "orderNumber",
] as const satisfies Key[];

const zFieldsToSortBy = z.enum(INCLUDED_KEYS);
const FieldsToSortBy = zFieldsToSortBy.Enum;
type FieldsToSortBy = z.infer<typeof zFieldsToSortBy>;

const zIn = ListParams.zSchema(zFieldsToSortBy);
type In = z.infer<typeof zIn>;

export { FieldsToSortBy, zFieldsToSortBy, zIn, zOut };
export type { In, Out };
